import CampoMoeda from '../../componentes/CampoMoeda'
import type { FormularioRepresentada } from '../../representadas/formularioRepresentada'
import { IconeMoedas, IconePorcento } from '../produtos/IconesDaFicha'
import { IconeCaminhao, IconeEscudo } from './IconesDaPolitica'
import { ESTILO_CAMPO, ESTILO_CARTAO_NOVO, ESTILO_ICONE_CARTAO, type PropsAba } from './estilosDaFornecedora'

// Spec 27/09 (1.3 e 1.5): o card da Politica Comercial foi partido em dois
// porque Condicoes | Formas ficam ENTRE o pedido minimo e o credito.
// "Prazo de pagamento padrao" saiu da tela (0 de 39 preenchidos em 27/09).
export function CampoPedidoMinimo({ form, setForm, editavel }: PropsAba) {
  const mudar = (p: Partial<FormularioRepresentada>) => setForm((f) => ({ ...f, ...p }))
  return (
    <div className={`${ESTILO_CARTAO_NOVO} flex items-center gap-3`}>
      <span className={ESTILO_ICONE_CARTAO}><IconeMoedas tamanho={18} /></span>
      <div className="min-w-0 flex-1">
        <label htmlFor="minimo" className="block text-sm font-semibold text-slate-800">Pedido mínimo (R$)</label>
      </div>
      <div className="w-28 shrink-0">
        <CampoMoeda id="minimo" value={form.pedidoMinimo} onChange={(v) => mudar({ pedidoMinimo: v })}
          disabled={!editavel} className={`${ESTILO_CAMPO} text-right text-sm py-1.5`} />
      </div>
    </div>
  )
}

export function CamposCreditoEFrete({ form, setForm, editavel }: PropsAba) {
  const mudar = (p: Partial<FormularioRepresentada>) => setForm((f) => ({ ...f, ...p }))
  const rotulo = 'flex items-center gap-1.5 text-xs font-medium text-slate-700 mb-1'
  return (
    <div className={`${ESTILO_CARTAO_NOVO} space-y-3`}>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label htmlFor="credito-sol" className={rotulo}><span className="text-teal-700"><IconePorcento tamanho={16} /></span>Crédito solicitado (R$)</label>
          <CampoMoeda id="credito-sol" value={form.limiteSolicitado} onChange={(v) => mudar({ limiteSolicitado: v })}
            disabled={!editavel} className={`${ESTILO_CAMPO} text-sm py-1.5`} />
        </div>
        <div>
          <label htmlFor="credito-apr" className={rotulo}><span className="text-teal-700"><IconeEscudo tamanho={16} /></span>Crédito aprovado (R$)</label>
          <CampoMoeda id="credito-apr" value={form.limiteAprovado} onChange={(v) => mudar({ limiteAprovado: v })}
            disabled={!editavel} className={`${ESTILO_CAMPO} text-sm py-1.5`} />
        </div>
      </div>
      <div>
        <label htmlFor="frete-padrao" className={rotulo}><span className="text-teal-700"><IconeCaminhao tamanho={16} /></span>Frete padrão</label>
        <select id="frete-padrao" value={form.fretePadrao} onChange={(e) => mudar({ fretePadrao: e.target.value })}
          disabled={!editavel} className={`${ESTILO_CAMPO} text-sm py-1.5`}>
          <option value="">Selecione</option>
          <option value="CIF">CIF</option>
          <option value="FOB">FOB</option>
          <option value="REDESPACHO">Redespacho</option>
        </select>
      </div>
    </div>
  )
}
